export default __webpack_public_path__ + "static/media/bse-payment-768.82884271.svg";